export default "__VITE_ASSET__62f468b8__"